import { Divider } from 'antd';
import React from 'react';
import { components } from 'react-select';
import styled, { css } from 'styled-components';
import { SingleLineOption } from 'components/atoms/select/custom-components';
import { OptionProps } from 'components/atoms/select/types';

const NonProjectActivity = styled.div<{ isSelected }>`
  margin: 0 16px;
  ${({ isSelected }) =>
    isSelected
      ? css`
          color: var(--white-100);
        `
      : css`
          color: var(--blue-60);
        `};
`;

export const ProjectOption = (props: OptionProps): JSX.Element => {
  const { data, isSelected, getStyles, ...restProps } = props;

  if (data.value === 1) {
    return (
      <>
        <components.Option
          getStyles={(a, b) => {
            return {
              ...getStyles(a, b),
              marginTop: 'var(--spacing-03)',
            };
          }}
          data={data}
          isSelected={isSelected}
          {...restProps}
        >
          <NonProjectActivity
            isSelected={isSelected}
            data-cy="timesheet.non-project-activity"
          >
            {data.label}
          </NonProjectActivity>
        </components.Option>
        <Divider
          style={{
            margin: 'var(--spacing-03)',
            minWidth: 'cal(100% - 2 * var(--spacing-05))',
            width: 'cal(100% - 2 * var(--spacing-05))',
          }}
        />
      </>
    );
  }

  return <SingleLineOption {...props} />;
};
